export const FACET_ICONS = {
    filter: "fa fa-filter",
    groupBy: "oi oi-group",
    groupByAsc: "fa fa-sort-numeric-asc",
    groupByDesc: "fa fa-sort-numeric-desc",
    favorite: "fa fa-star",
};

export const FACET_COLORS = {
    filter: "primary",
    groupBy: "action",
    favorite: "warning",
};

export const GROUPABLE_TYPES = [
    "boolean",
    "char",
    "date",
    "datetime",
    "integer",
    "many2one",
    "many2many",
    "selection",
    "tags",
];
